import type { PaletteOptions } from '@mui/material';
import { blue, green, red } from '@mui/material/colors';
import { black, hero, white, yellow } from '../shared/primitives-v4';

export const muiV4Palette: PaletteOptions = {
  mode: 'dark',
  common: { black, white },
  primary: {
    main: hero[500],
    light: hero[400],
    dark: hero[600],
    contrastText: white,
  },
  secondary: {
    main: white,
    light: white,
    dark: white,
    contrastText: blue[600],
  },
  info: {
    main: blue[500],
    light: blue[400],
    dark: blue[600],
    contrastText: white,
  },
  success: {
    main: green[500],
    light: green[400],
    dark: green[600],
    contrastText: white,
  },
  error: {
    main: red[500],
    light: red[400],
    dark: red[600],
    contrastText: white,
  },
  warning: {
    main: yellow[500],
    light: yellow[400],
    dark: yellow[600],
    contrastText: white,
  },
};
